module.exports = __webpack_public_path__ + "static/media/creation_design_LTM.5849fd73.doc";